import { createContext } from 'react';
import { SEARCH } from '../../constants/searchOrders.constant';

export const SearchOrdersContext = createContext({
  search: SEARCH(),
  setSearch: () => {},
});

export const SearchOrdersProvider = SearchOrdersContext.Provider;
